<info>
    <header>
        Reg nr. og konto nr. 
    </header>
    <content>
        <p class="header">Hvor finder jeg registrerings og kontonummeret?</p>
        <p>Registreringsnummeret er på 4 cifre og kontonummeret er på mellem 7 til 10 cifre</p>
        <p>Du kan finde registreringsnummer og kontonummer på bagsiden af dit betalingskort (VISA/Dankort). Pas på ikke at forveksle kontonummeret med kort-nummeret, som er placeret på kortets forside.</p>
        <p>Du kan også finde dit registrerings- og kontonummer på dit kontoudtog fra banken.</p>

        <div class="credit-card mb-2">
            <div class="credit-card-part">
                <div class="credit-card-black-line"></div>
                <div class="credit-card-back-content">
                    <div class="credit-card-reg">Reg.nr. XXXX Kontonr. XXXXXXXXXX</div>
                    <div class="credit-card-secret">
                        <p class="credit-card-secret--last">&nbsp;</p>
                    </div>
                    <img class="credit-card-square" src="assets/images/banner/din-bank-119x20.png">
                    <img class="credit-card-logo" src="assets/images/banner/ddk-flag-900x266.png">
                </div>
            </div>
        </div>
    </content>
</info>
